import DashboardIcon from "@mui/icons-material/Dashboard";
import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BadgeIcon from "@mui/icons-material/Badge";
import PeopleIcon from "@mui/icons-material/People";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SettingsIcon from "@mui/icons-material/Settings";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CategoryIcon from "@mui/icons-material/Category";
import CreditCardIcon from "@mui/icons-material/CreditCard";
export interface MenuItem {
  text: string;
  icon: JSX.Element;
  path?: string;
  children?: MenuItem[];
}

export const menuItems: MenuItem[] = [
  { text: "Dashboard", icon: <DashboardIcon />, path: "/admin/dashboard" },
  {
    text: "Washes",
    icon: <LocalCarWashIcon />,
    path: "/admin/washes",
  },
  // {
  //   text: "Entries",
  //   icon: <ReceiptLongIcon />,
  //   path: "/admin/entries",
  // },
  { text: "Vehicles", icon: <DirectionsCarIcon />, path: "/admin/vehicles" },
  {
    text: "Employe Management",
    icon: <BadgeIcon />,
    path: "/admin/employees",
  },
  { text: "Customers", icon: <PeopleIcon />, path: "/admin/customers" },
  {
    text: "Reports",
    icon: <AssessmentIcon />,
    children: [
      {
        text: "Transaction Report",
        icon: <ReceiptIcon />,
        path: "/admin/transaction-report",
      },
      // {
      //   text: "Washes Report",
      //   icon: <LocalCarWashIcon />,
      //   path: "/washes-report",
      // },
    ],
  },
  {
    text: "Configurations",
    icon: <SettingsIcon />,
    children: [
      {
        text: "Ledgers",
        icon: <ReceiptLongIcon />,
        path: "/admin/ledgers",
      },
      {
        text: "Master Services",
        icon: <AutoFixHighIcon />,
        path: "/admin/master-services",
      },
      {
        text: "Natures",
        icon: <CategoryIcon />,
        path: "/admin/natures",
      },
      {
        text: "Bank Accounts",
        icon: <CreditCardIcon />,
        path: "/admin/bank-accounts",
      },
      {
        text: "Cash Transfer",
        icon: <CreditCardIcon />,
        path: "/admin/cash-transfer",
      },
    ],
  },
];
